import { render, staticRenderFns } from "./DataReplay.vue?vue&type=template&id=aff1f3ca&scoped=true&"
import script from "./DataReplay.vue?vue&type=script&lang=js&"
export * from "./DataReplay.vue?vue&type=script&lang=js&"
import style0 from "./DataReplay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataReplay.vue?vue&type=style&index=1&id=aff1f3ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff1f3ca",
  null
  
)

export default component.exports